import axios from 'axios';
import store from '@/store'
import {apiAxios} from "@/service/ApiClient";
import i18n from "@/helpers/i18n";


let refreshTokenRequest: any = store.getters['newauth/isRefresh'];
let isRefresh = false


let token = localStorage['access-token'];
const refresh = localStorage['refresh-token']

export default function setup() {
    apiAxios.interceptors.request.use(async function (config) {
        const locale = localStorage['locale']
        if (['ru', 'de', 'en'].includes(locale)) {
            config.headers.common['LF-Localization'] = locale;
        } else {
            config.headers.common['LF-Localization'] = 'ru';
        }
        if (!localStorage['region'] || !['RU','EU'].includes(localStorage['region'])){
            // console.log(localStorage['region'])
            store.commit('newauth/clear')
        }
        if (isRefresh) {
            if (config.url && config.url.indexOf('/token/refresh') !== -1) {
                return config;
            }
            token = await refreshTokenRequest;

        } else {
            token = localStorage['access-token'];
        }

        if (token) {
            // console.log(token)
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete apiAxios.defaults.headers.common['Authorization']
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });
}


apiAxios.interceptors.response.use(
    (response) => {
        return response;
    }, async function (error) {
        const originalRequest = error.config;
        if (error.response.status === 403) {
            if(error.response.data.error === 'invalid_refresh_token'){
                store.commit('newauth/clear')
            } else{
                store.commit('dialog/SetFullError',{
                    titleError:i18n.t('error.some_error.403_title'),
                    isBtnHome:true
                })
                store.commit('dialog/SetFullPlanShow',false)
            }
        }
        if (error.response.status === 401) {
            isRefresh = true
            const {data, status} = await store.dispatch('newauth/refreshToken');
            if (status == 200 || status === 201) {
                const accessToken = data.data.access
                store.commit('newauth/tokenSetup', {
                    access_token: accessToken,
                    refresh_token: data.data.refresh,
                })
                originalRequest.headers.Authorization = 'Bearer ' + accessToken;
                apiAxios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
                isRefresh = false
                return await apiAxios(originalRequest)
            }
        }
        return Promise.reject(error);
    });
